import * as React from "react";
import { Container } from "../../Container";
import { LabelStore } from "../../flux/Label/LabelStore";
import { Polyglot } from "../../../polyglot";

interface Props
{
    polyglot: Polyglot;
    labelStore: LabelStore;
}

// TableTitle manages title of the table on each Entity tab
export class TableTitle extends React.Component<Props, any>
{
    render()
    {
        const { labelStore, polyglot } = this.props;
        return (
            <Container subscribe={[labelStore]} render={() => <label>{labelStore.getLabel() || polyglot.t('misc.nothing_searched_msg')}</label>} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Table/TableTitle.tsx